import { Box, Button, Typography } from '@mui/material';
import { type ReactNode } from 'react';
import { Clear } from '@/static';
import { type ModalContentProps } from '../../../state';
import styles from './styles';

type Props = {
  children: ReactNode;
  title: string;
  closeModal: ModalContentProps['closeModal'];
  onAccept?: () => void;
  acceptText?: string;
  acceptDisabled?: boolean;
  onCancel?: () => void;
  cancelText?: string;
};

const ModalLayout = ({
  children,
  title,
  closeModal,
  onAccept,
  acceptText = 'OK',
  acceptDisabled = false,
  onCancel,
  cancelText = 'Cancel',
}: Props) => (
  <Box sx={styles.root}>
    <Box sx={styles.header}>
      <Button
        endIcon={<Clear />}
        variant="text"
        onClick={closeModal}
        sx={styles.closeButton}
        size="small"
      >
        Close
      </Button>
    </Box>

    <Typography sx={styles.title} typography="h1">
      {title}
    </Typography>

    <Box sx={styles.body}>{children}</Box>

    {(onAccept || onCancel) && (
      <Box sx={styles.actions}>
        {onCancel && (
          <Button onClick={onCancel} variant="outlined">
            {cancelText}
          </Button>
        )}

        {onAccept && (
          <Button
            onClick={onAccept}
            variant="mainBtn"
            disabled={acceptDisabled}
          >
            {acceptText}
          </Button>
        )}
      </Box>
    )}
  </Box>
);

export default ModalLayout;
